<template>
  <div>
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <ul class="warning_list">
      <li style="font-weight: bold;">{{ data.title }} </li>
      <li>{{ data.content }}</li>
      <li>
        <div>
          涉及信息：
        </div>
        <div>
          {{ data.specially }}
        </div>
      </li>
      <li>
        <div>
          信息原链接：
        </div>
        <a :href="data.url" target="_blank">
          {{ data.url }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import listJson from './message.json'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    // 回获取路由参数
    const { id } = this.$route.query;
    let data = listJson.find(item => item.id === id);
    this.data = data;
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 0 } })
    }
  },
}
</script>
<style lang="less" scoped>
.warning_list {
  padding: 20px;

  li {
    margin-top: 10px;
    font-size: 0.14rem;
    color: rgb(16, 16, 16);
    line-height: 20px;
  }
}
</style>